import React, { Component } from 'react'
import { Row, Col } from 'reactstrap'
import { showCurrencyFormat } from '../../../../utils';
import NumericLabel from 'react-pretty-numbers';
import { Tooltip } from '@material-ui/core';
import { InfoOutlined } from '@material-ui/icons';
import { hanwahaInstance, titanInstance } from '../../../../shared_elements/components';
import { jetStreamInstance } from '../../../../lease_management/Leases';

export default class CreditDebitNote extends Component{
  constructor(props){
    super(props)
  }
  render(){
    const { type, invoiceInfo, invoice_item, index, error, showJCT ,isJac,newInvoiceDate} = this.props
    if(type === 'view'){
      return(
        <tr>
          <td className="invoice-penalty-description-block" style={{lineHeight:'5px', width:hanwahaInstance?'150px':''}} >
              <h6 className="para-ui"> {newInvoiceDate?invoice_item?.invoice_item_name:invoice_item?.description||'--' }</h6><br/>
              {titanInstance && invoice_item?.serial_no ? (<p style={{fontSize:'10px'}}>[SN : {invoice_item?.serial_no}]</p>):null}
          </td>
          {hanwahaInstance ?
            <td className="invoice-description-block">
              <h6 className="para-ui"> {invoice_item.description}</h6>
            </td> : jetStreamInstance ?
            <td className="invoice-description-block">
              <h6 className="para-ui"> {invoice_item?.sale_description ? invoice_item.sale_description : invoice_item.description}</h6>
            </td> : null
          }
            {/* </td> */}
          {titanInstance && invoiceInfo.is_reserve_releted  ?
            <td className="para-ui">
              {invoice_item.fh_fc_ration || '--'}
            </td> : null}
          <td>
            <h6 className="para-ui">
              <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                {invoice_item.rate_per_unit ? invoice_item.rate_per_unit: '0'}
              </NumericLabel>
            </h6>
          </td>
          {isJac?null:
          <td>
            <h6 className="para-ui"> {invoice_item.tax_rate ? invoice_item.tax_rate:'0'}%</h6>
          </td>}
          {isJac?null:
          <td>
            <h6 className="para-ui">
              <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                {invoice_item.tax_amount ? invoice_item.tax_amount: '0'}
              </NumericLabel>
            </h6>
          </td>}
          <td>
            <h6 className="para-ui">
                <div style={{ alignItems: 'center', gap: 4 }}>
                  <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                     {invoiceInfo.invoice_type === 5 ? -(invoice_item.sub_total ? invoice_item.sub_total : 0) : (invoice_item.sub_total ? invoice_item.sub_total : 0)}
                  </NumericLabel>
                  {invoice_item.excess_amount > 0 ?
                    <Tooltip title={`Excess Amount:${invoiceInfo?.currency === 'USD' ? 'US$' : invoiceInfo?.currency === 'EUR' ? '€' : ''}${invoice_item.excess_amount}`}>
                      <InfoOutlined style={{ color: '#aeacac' }} fontSize="small" />
                    </Tooltip> : null}
                </div>
            </h6>
          </td>
          {showJCT ? <>
            <td>
              <h6 className="para-ui"> 10% </h6>
            </td>
            <td>
              <h6 className="para-ui">
                <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                  {invoiceInfo.invoice_type === 5 ? -(invoice_item.sub_total ? invoice_item.sub_total / 10 : 0) : (invoice_item.sub_total ? invoice_item.sub_total / 10 : 0)}
                </NumericLabel>
              </h6>
            </td>
          </> : null}
        </tr>
      )
    }else{
      return(
        <tr key={index}>
          <td className="invoice-penalty-description-block" style={{width:hanwahaInstance?'150px':''}}>
              <h6 className="para-ui"> {newInvoiceDate?invoice_item?.invoice_item_name:invoice_item?.description||'--' }</h6>
              {titanInstance && invoice_item?.serial_no ? (<p style={{fontSize:'10px'}}>[SN : {invoice_item?.serial_no}]</p>):null}
          </td>
          {hanwahaInstance ?
            <td className="invoice-description-block" style={{ width: hanwahaInstance ? '250px' : '' }}>
              <textarea
                value={invoice_item?.description || ''}
                onChange={(e) => { this.props.updateInvoiceItemField(e.target.value, 'description', index); if (error?.description && Array.isArray(error.description)) { error.description[index] = ''; } }}
              />
              <h6 className="error-msg">{error.description?.[index]}</h6>
            </td> : jetStreamInstance ?
            <td>
              <h6 className="para-ui">{invoice_item?.sale_description ? invoice_item.sale_description : invoice_item.description}</h6>
            </td> : null
          }
          {titanInstance && invoiceInfo.is_reserve_releted  ?
            <td className="para-ui">
              {invoice_item.fh_fc_ration || '--'}
            </td> : null}     
              <td className="invoice-usd-day" style={{minWidth:hanwahaInstance?'150px':''}}>
            <input type="text"  value={invoice_item.rate_per_unit ? invoice_item.rate_per_unit:''}
              onChange={(e) => this.props.updateInvoiceItemField(e.target.value, 'rate_per_unit', index)}
            />
            <h6 className="error-msg">{error.rate_per_unit}</h6>
          </td>
          {isJac ?null:
          <td style={{width:hanwahaInstance?'100px':''}}>
            <input type="text"  value={invoice_item.tax_rate? invoice_item.tax_rate:''}
              onChange={(e) => this.props.updateInvoiceItemField(e.target.value, 'tax_rate',index)}
            />
            <h6 className="error-msg">{error.tax_rate}</h6>
          </td>}
          {isJac?null:
          <td>
          <h6 className="para-ui">
              <NumericLabel params={showCurrencyFormat()}>
                {invoice_item.tax_amount}
              </NumericLabel>
            </h6>
            </td>}
          <td>
          <h6 className="para-ui">
            {
              invoice_item.sub_total && invoice_item.invoice_item_type_id && invoice_item.invoice_item_type_id.id === 5 && invoice_item.sub_total > 0 ?
              <NumericLabel params={showCurrencyFormat()}>
                {0 - invoice_item.sub_total}
              </NumericLabel>
              :<NumericLabel params={showCurrencyFormat()}>
                {invoice_item.sub_total}
              </NumericLabel>
            }
            </h6>
            </td>
            {showJCT ? <>
            <td>
              <h6 className="para-ui"> 10% </h6>
            </td>
            <td>
              <h6 className="para-ui">
                <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                  {invoiceInfo.invoice_type === 5 ? -(invoice_item.sub_total ? invoice_item.sub_total / 10 : 0) : (invoice_item.sub_total ? invoice_item.sub_total / 10 : 0)}
                </NumericLabel>
              </h6>
            </td>
          </> : null}
        </tr>
      )
    }
  }
}
